import React,{ ReactNode } from 'react';
import arrowIcon from '@ingka/ssr-icon/paths/arrow-right';
import SSRIcon from '@ingka/ssr-icon';
import {
  ArrowIcon,
  ButtonWrapper,
  Children,
  Content,
  ImageWrapper,
  Label,
  Eventtitle,
  Wrapper,
  StyledLink,
  SlideShowWrapper,
} from './style';
import Badges, { Colors } from './Badges';
import AspectRatioImage from '../AspectRatioImage';
import ConditionalRender from '../ConditionalRender';

type PropsType = {
  title: string;
  label: string;
  aspectRatioImageProps: {
    src: string;
    srcSet: string;
    ratio: 'square' | 'standard' | 'wide' | 'portrait';
    loading?: string;
  };
  children: ReactNode;
  buttonText: string;
  badges?: [string, Colors][];
  eventPath: string;
  inSlideShow: boolean;
  storeName?: string;
};

const Card = (props: PropsType) => {
  const WrapperElement = props.inSlideShow ? SlideShowWrapper : Wrapper;

  return (
    <WrapperElement>
      <StyledLink to={props.eventPath} aria-label={props.buttonText}>
        <ImageWrapper>
          <Badges badges={props.badges || []} />
          <AspectRatioImage
            src={props.aspectRatioImageProps.src}
            srcSet={props.aspectRatioImageProps.srcSet}
            ratio={props.aspectRatioImageProps.ratio}
            loading={props.aspectRatioImageProps.loading}
            alt=""
          />
        </ImageWrapper>
        <Content aria-hidden="true">
          <Eventtitle>
            {props.title}
          </Eventtitle>
          <ConditionalRender predicate={Boolean(props.storeName)}>
            <p> {props.storeName} </p>
          </ConditionalRender>
          <Label>
            {props.label}  
          </Label>
          <Children>
            {props.children}
          </Children>

          <ButtonWrapper>
            <ArrowIcon aria-hidden="true">
              <SSRIcon paths={arrowIcon} />
            </ArrowIcon>
          </ButtonWrapper>
        </Content>
      </StyledLink>
    </WrapperElement>
  );
};

export default Card;